// src/assets/icons/Club.jsx
import React from 'react';

const Club = ({ color = "white", opacity = 0.7 }) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke={color} strokeOpacity={opacity} strokeWidth="1.24" strokeMiterlimit="10" strokeLinecap="round" />
            <path d="M12 8.21016L8.43328 11.2022M12 8.21016L15.5667 11.2022M12 8.21016V5.51156M8.43328 11.2022L9.375 15M8.43328 11.2022L5.955 10.1522M9.375 15H14.625M9.375 15L8.0625 17.25M14.625 15L15.5667 11.2022M14.625 15L15.9375 17.25L14.625 20.5781M15.5667 11.2022L18.045 10.1522M18.045 10.1522L19.2534 6.71813M18.045 10.1522L20.9531 12.6548M5.955 10.1522L4.74656 6.71813M5.955 10.1522L3.04688 12.6548M12 5.51156L15 3.51281M12 5.51156L9 3.51234M19.2534 17.25H16.0312M8.0625 17.25L9.39234 20.6016M8.0625 17.25H4.76391" stroke={color} strokeOpacity={opacity} strokeWidth="1.24" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    );
};

export default Club;
